export default "__VITE_ASSET__07025210__"